import { initPoll } from "crosstalk-comments-livechat-sdk";
export function autoInitPolls() {
    const pollDivs = document.querySelectorAll('div[data-crosstalk-poll]');
    const pollEmbeds = [];
    pollDivs.forEach(pollDiv => {
        const config = {
            wp: pollDiv.dataset.wp,
            url: pollDiv.dataset.url || "",
            pageID: pollDiv.dataset.pageId || "",
            theme: pollDiv.dataset.theme || "light",
            pollID: pollDiv.dataset.pollId || ""
        };
        const instance = initPoll(pollDiv, config);
        if (instance)
            pollEmbeds.push(instance);
    });
    return pollEmbeds;
}
